export default "__VITE_ASSET__SHVrmW85__"